(function() {
    'use strict';
    
a3_cabin_reports.config(compileProviderConfig);

    /**
    * @memberof CabinReports
    * @ngdoc config
    * @name compileProviderConfig
    * @description 
    *   Config aHref Sanitization Whitelist (make "safe" to download image from data url)
    * @ngInject
    */
function compileProviderConfig($compileProvider) {
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|ghttps?|ms-appx|x-wmapp0|data|tel):/);
}
    
})();

